<template>
  <div class="report__content">
    <form>
      <div class="wrapper">
        <div class="form__row">
          <h4 class="form__row-title">Krótki opis przypadku*</h4>
          <div class="form__col--full">
            <textarea rows="4" v-model="medicalData.shortDescription" ></textarea>
            <div v-if="errors.shortDescription" class="form__inline-error">
              {{errors.shortDescription}}
            </div>
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Lokalizacja guza pierwotnego*</h4>
          <div class="form__col--full">
            <input type="text" class="form__field" v-model="medicalData.primaryTumorLocation" />
            <div v-if="errors.primaryTumorLocation" class="form__inline-error">
                {{errors.primaryTumorLocation}}
            </div>
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Operacja raka jelita grubego/odbytnicy (rodzaj zabiegu i data)*</h4>
          <div class="form__col--full">
            <textarea rows="4" v-model="medicalData.typeOfPrimaryTumorSurgeryPerformed"></textarea>
            <div v-if="errors.typeOfPrimaryTumorSurgeryPerformed" class="form__inline-error">
              {{errors.typeOfPrimaryTumorSurgeryPerformed}}
            </div>
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Powikłania pooperacyjne</h4>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.postoperativeComplications.postoperativeFistula" />
              <div class="checkbox"></div>
              <span>Przetoka pooperacyjna</span>
            </label>
            <div v-if="medicalData.postoperativeComplications.postoperativeFistula" class="mb-5">
              <input type="text"
                v-model="medicalData.postoperativeComplications.postoperativeFistulaDescription"
                placeholder="Opis *"
              >
              <div v-if="errors.postoperativeComplications.postoperativeFistulaDescription" class="form__inline-error">
                {{errors.postoperativeComplications.postoperativeFistulaDescription}}
              </div>
            </div>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.postoperativeComplications.infection" />
              <div class="checkbox"></div>
              <span>Zakażenie</span>
            </label>
            <div v-if="medicalData.postoperativeComplications.infection" class="mb-5">
              <input type="text"
                v-model="medicalData.postoperativeComplications.infectionDescription"
                placeholder="Opis *"
              >
              <div v-if="errors.postoperativeComplications.infectionDescription" class="form__inline-error">
                {{errors.postoperativeComplications.infectionDescription}}
              </div>
            </div>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.postoperativeComplications.abscess" />
              <div class="checkbox"></div>
              <span>Ropień</span>
            </label>
            <div v-if="medicalData.postoperativeComplications.abscess" class="mb-5">
              <input type="text"
                v-model="medicalData.postoperativeComplications.abscessDescription"
                placeholder="Opis *"
              >
              <div v-if="errors.postoperativeComplications.abscessDescription" class="form__inline-error">
                {{errors.postoperativeComplications.abscessDescription}}
              </div>
            </div>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.postoperativeComplications.other"/>
              <div class="checkbox"></div>
              <span>Inne</span>
            </label>
            <div v-if="medicalData.postoperativeComplications.other" class="mb-5">
              <input type="text"
                v-model="medicalData.postoperativeComplications.description"
                placeholder="Jakie? *"
              >
              <div v-if="errors.postoperativeComplications.description" class="form__inline-error">
                {{errors.postoperativeComplications.description}}
              </div>
            </div>
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Histopatologiczne rozpoznanie guza*</h4>
          <div class="form__col--full">
            <textarea rows="4" v-model="medicalData.histopathologicalDiagnosisOfTheTumor"></textarea>
            <div v-if="errors.histopathologicalDiagnosisOfTheTumor" class="form__inline-error">
              {{errors.histopathologicalDiagnosisOfTheTumor}}
            </div>
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Klasyfikacja guza w TNM*</h4>
          <div class="form__col--full">
            <input type="text" class="form__field" v-model="medicalData.tnmTumorClassification"/>
            <div v-if="errors.tnmTumorClassification" class="form__inline-error">
              {{errors.tnmTumorClassification}}
            </div>
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Mutacje</h4>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.mutations.KARS"/>
              <div class="checkbox"></div>
              <span>KRAS</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.mutations.BRAF"/>
              <div class="checkbox"></div>
              <span>BRAF</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.mutations.other"/>
              <div class="checkbox"></div>
              <span>Inne</span>
            </label>
            <div v-if="medicalData.mutations.other" class="mb-5">
              <input type="text"
                v-model="medicalData.mutations.description"
                placeholder="Jakie? *"
              >
              <div v-if="errors.mutations.description" class="form__inline-error">
                {{errors.mutations.description}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="wrapper">
        <div class="form__row">
          <h4 class="form__row-title">Leczenie adjuwantowe*</h4>
          <div v-if="errors.adjuvantTreatment.group" class="form__inline-full-error">
            {{errors.adjuvantTreatment.group}}
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.adjuvantTreatment.radiotherapy"/>
              <div class="checkbox"></div>
              <span>radioterapia</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.adjuvantTreatment.hormoneTherapy"/>
              <div class="checkbox"></div>
              <span>hormonoterapia</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.adjuvantTreatment.monoclonalAntibodies"/>
              <div class="checkbox"></div>
              <span>przeciwciała monoklonalne</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label class="form__label--inline">
              <input type="checkbox" v-model="medicalData.adjuvantTreatment.chemotherapy" />
              <div class="checkbox"></div>
              <span>chemioterapia</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="medicalData.adjuvantTreatment.none"/>
              <div class="checkbox"></div>
              <span>brak</span>
            </label>
          </div>


          <div v-if="medicalData.adjuvantTreatment.chemotherapy" class="form__col--full form__row">
            <hr class="form__col--full mt-4">
            <div class="form__col-1-3">
              <h4 class="form__field-title">Rodzaj chemioterapii*</h4>
              <input type="text" class="form__field--inline" v-model="medicalData.adjuvantTreatment.chemotherapyType" />
              <div v-if="errors.adjuvantTreatment.chemotherapyType" class="form__inline-error">
                {{errors.adjuvantTreatment.chemotherapyType}}
              </div>
            </div>
            <div class="form__col-1-3">
              <h4 class="form__field-title">Liczba kursów*</h4>
              <input type="number" class="form__field--inline" v-model="medicalData.adjuvantTreatment.chemotherapyAmount" />
              <div v-if="errors.adjuvantTreatment.chemotherapyAmount" class="form__inline-error">
                {{errors.adjuvantTreatment.chemotherapyAmount}}
              </div>
            </div>
            <div class="form__col-1-3">
              <h4 class="form__field-title">Data ostatniego kursu*</h4>
              <input type="date" class="form__field--inline" v-model="medicalData.adjuvantTreatment.endDateOfTheLastCourse" />
              <div v-if="errors.adjuvantTreatment.endDateOfTheLastCourse" class="form__inline-error">
                {{errors.adjuvantTreatment.endDateOfTheLastCourse}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="wrapper">
        <div class="form__row">
          <h4 class="form__row-title">Inne operacje wykonane w przeszłości*</h4>
          <textarea rows="4" v-model="medicalData.otherOperationsPerformedInThePast"></textarea>
          <div v-if="errors.otherOperationsPerformedInThePast" class="form__inline-error">
            {{errors.otherOperationsPerformedInThePast}}
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Lokalizacja przerzutów do wątroby (orientacyjna)*</h4>
          <input type="text" v-model="medicalData.locationOfLiverMetastases" />
          <div v-if="errors.locationOfLiverMetastases" class="form__inline-error">
            {{errors.locationOfLiverMetastases}}
          </div>
        </div>
        <div class="form__row">
          <h4 class="form__row-title">Opis z badań obrazowych</h4>
        </div>
        <div class="form__row">
          <div class="form__col-1-4">Liczba przerzutów</div>
          <div class="form__col-1-4">
            <input type="number" v-model="medicalData.descriptionOfImagingTests.amount"/>
          </div>
        </div>
        <div class="form__row">
          <div class="form__col-1-4">Wielkość największego (w cm)</div>
          <div class="form__col-1-4">
            <input type="number" v-model="medicalData.descriptionOfImagingTests.size"/>
          </div>
        </div>
        <div class="form__row">
          <div class="form__col-1-4">Segmenty</div>
          <div class="form__col-1-4">
            <input type="text" v-model="medicalData.descriptionOfImagingTests.segments"/>
          </div>
        </div>
      </div>
      <hr />
      <div class="wrapper">
        <div class="form__row">
          <h4 class="form__row-title">Choroby współistniejące*</h4>
          <input type="text" v-model="medicalData.comorbidities"/>
          <div v-if="errors.comorbidities" class="form__inline-error">
            {{errors.comorbidities}}
          </div>
        </div>
      </div>
      <hr />
      <div class="wrapper">
        <div class="form__row">
          <h4 class="form__row-title">Stosowane leki przeciwzakrzepowe/antykoagulanty*</h4>
          <input type="text" v-model="medicalData.anticoagulantsUsed"/>
          <div v-if="errors.anticoagulantsUsed" class="form__inline-error">
            {{errors.anticoagulantsUsed}}
          </div>
        </div>
        <div class="form__row form__row--center">
          <a @click="$emit('back', 1)" class="btn btn--blue">Powrót</a>
          <a class="btn" @click="nextPage">Dalej</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "Medical",
  data() {
    return {
      errors: {
        shortDescription: '',
        primaryTumorLocation: '',
        typeOfPrimaryTumorSurgeryPerformed: "",
        postoperativeComplications: {
          postoperativeFistulaDescription: '',
          infectionDescription: '',
          abscessDescription: '',
          description: '',
        },
        histopathologicalDiagnosisOfTheTumor: '',
        tnmTumorClassification: '',
        adjuvantTreatment: {
          chemotherapyType: '',
          chemotherapyAmount: '',
          endDateOfTheLastCourse: '',
          group: "",
        },
        otherOperationsPerformedInThePast: '',
        locationOfLiverMetastases: '',
        mutations: {
          description: '',
        },
        comorbidities: '',
        anticoagulantsUsed: '',
      },
      medicalData: {
        shortDescription: '',
        primaryTumorLocation: '',
        typeOfPrimaryTumorSurgeryPerformed: '',
        postoperativeComplications: {
          postoperativeFistula: false,
          postoperativeFistulaDescription: '',
          infection: false,
          infectionDescription: '',
          abscess: false,
          abscessDescription: '',
          other: false,
          description: ''
        },
        histopathologicalDiagnosisOfTheTumor: '',
        tnmTumorClassification: '',
        mutations: {
          KARS: false,
          BRAF: false,
          other: false,
          description: ''
        },
        adjuvantTreatment: {
          radiotherapy: false,
          hormoneTherapy: false,
          monoclonalAntibodies: false,
          chemotherapy: false,
          none: false,
          chemotherapyType: "",
          chemotherapyAmount: "",
          endDateOfTheLastCourse: ""
        },
        otherOperationsPerformedInThePast: '',
        locationOfLiverMetastases: '',
        descriptionOfImagingTests: {
          amount: '',
          size: '',
          segments: ''
        },
        comorbidities: '',
        anticoagulantsUsed: ''
      }
    };
  },
  methods: {
    nextPage() {
      // check required fields
      const fieldPairs = {
        postoperativeComplications: [
          ['postoperativeFistula', 'postoperativeFistulaDescription'],
          ['infection', 'infectionDescription'],
          ['abscess', 'abscessDescription'],
          ['other', 'description'],
        ],
        adjuvantTreatment: [
          ['chemotherapy','chemotherapyType'],
          ['chemotherapy','chemotherapyAmount'],
          ['chemotherapy','endDateOfTheLastCourse'],
        ],
        mutations: [
          ['other', 'description'],
        ]
      };

      for (const [group, fields] of Object.entries(fieldPairs)) {
        for (const [firstField, secondField] of fields) {
          this.checkPairIfNotEmpty(group, firstField, secondField);
        }
      }

      this.checkIfNotEmpty('comorbidities');
      this.checkIfNotEmpty('typeOfPrimaryTumorSurgeryPerformed');
      this.checkIfNotEmpty('shortDescription');
      this.checkIfNotEmpty('primaryTumorLocation');
      this.checkIfNotEmpty('histopathologicalDiagnosisOfTheTumor');
      this.checkIfNotEmpty('tnmTumorClassification');
      this.checkIfNotEmpty('otherOperationsPerformedInThePast');
      this.checkIfNotEmpty('locationOfLiverMetastases');
      this.checkIfNotEmpty('anticoagulantsUsed');

      const { radiotherapy, hormoneTherapy, monoclonalAntibodies, chemotherapy, none } = this.medicalData.adjuvantTreatment;
      this.errors.adjuvantTreatment.group = "";
      if (!radiotherapy && !hormoneTherapy && !monoclonalAntibodies && !chemotherapy && !none) {
        this.errors.adjuvantTreatment.group = "Przynajmniej jedna opcja musi być zaznaczona";
      }

      // send data to store
      if (this.noErrors()) {
        this.$store.commit('updateMedicalData', this.medicalData)
        this.$emit("next", 3);
      } else {
        setTimeout(() => {
          const firstError = document.querySelector('.form__inline-error');
          const yOffset = -200;
          if (firstError) {
            const y = firstError.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
          }
        }, 200)
      }
    },

    checkPairIfNotEmpty(group, firstField, secondField) {
        this.errors[group][secondField] = "";

        if (
          this.medicalData[group][firstField]
          && this.medicalData[group][secondField] == ""
        ) {
          this.errors[group][secondField] = "To pole jest wymagane"
        }
    },

    checkIfNotEmpty(fieldName) {
      this.errors[fieldName] = "";
      if (this.medicalData[fieldName] == "") {
        this.errors[fieldName] = "To pole jest wymagane";
      }
    },

    noErrors() {
      const errors = Object.values(this.errors).map(error => {
        if (typeof error === "object" && error !== null) {
          return Object.values(error)
        } else {
          return error;
        }
      }).flat()

      return !errors.filter(el => el != "").length;
    }
  }
};
</script>

<style lang="scss">
</style>
